<template>
	<div class="row">
		<div class="col col-md-3 col-sm-4">
			<div>
				<b-form-datepicker size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" class="mb-1" today-button close-button locale="zh"></b-form-datepicker>
			</div>
			<PopularTable 
				:items="items" 
				:isBusy="isBusy" 
				@show-kline="show_kline"
			/>
		</div>
		<div class="col col-md-9 col-sm-8">
			<!-- <StockKlineWithPopular  :symbol_code="symbol_code"  :title="symbol_code" :subText="symbol_name"></StockKlineWithPopular> -->
			<StockMultiChart  :symbol_code="symbol_code"  :symbol_name="symbol_name"></StockMultiChart>
			<div role="group">
				<label for="input-live">股票代码:</label>
					<b-form-input
					id="input-symbol_code"
					v-model="symbol_code"
					:state="nameState"
					aria-describedby="input-live-help input-live-feedback"
					placeholder="6位股票代码"
					trim
					style="width: 200px;"></b-form-input>
					<!-- This will only be shown if the preceding input has an invalid state -->
					<b-form-invalid-feedback id="input-live-feedback">
						请输入6位股票代码
					</b-form-invalid-feedback>
					<!-- This is a form text block (formerly known as help block) -->
					<!-- <b-form-text id="input-live-help">输入6位股票代码,自动切换图形</b-form-text> -->
			</div>
    </div>
  </div>
</template>

<script>
	// import PopularStock from 'components/sentiment/PopularStock.vue'
	// import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockMultiChart from 'components/stock/StockMultiChart.vue'
	import PopularTable from 'components/sentiment/PopularTable.vue'
	// import Moment from 'moment'
	import {request_zzquant} from "network/request.js"
	
	export default {
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + this.mendZero((now.getMonth()) + 1) + '-' + this.mendZero(now.getDate());
			return {
				date1: today,
				symbol_name:"",
				symbol_code:"600196",
				isBusy: true,
				items: []
			}
		},
		computed:{
			nameState() {
				if (this.symbol_code.length == 6){
					return true
				}
				return false
			}
		},
		components: {
			// PopularStock,
			// StockKlineWithPopular,
			StockMultiChart,
			PopularTable
		},
		mounted() {
			this.load_popular_data();
		},
		methods:{
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			dateDisabled(ymd, date) {
				// 禁用周末和未来日期
				const weekday = date.getDay();
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				return (weekday === 0 || weekday === 6 || date > today);
			},
			onDatePicked() {
				this.load_popular_data();
			},
			show_kline(symbol_code){
				this.symbol_code = symbol_code
				console.log(symbol_code)
			},
			load_popular_data(){
				let url = 'open/sentiment/media/ths2/top?date1='+ this.date1 +'&top_n=100'
				request_zzquant({
					'url': url
				}).then((resp1) => {
					// console.log(resp1);
					this.items = resp1.data.data
					this.isBusy = false
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped>
</style>
